export default {
  actualRates: null,
}
